import { ANONYMOUS_REVIEWER_NAME } from "../ReviewsSectionV2/anonymousReviewer";

interface SchemaReviewItem {
  anonymous?: boolean;
  user_details?: { name?: string | null } | null;
}

/**
 * JSON-LD Review `author.name`. Anonymous reviews use "Anonymous Student", and the name is never
 * emitted blank — a blank name falls back to "Anonymous Student" too.
 */
const getReviewAuthorName = (item?: SchemaReviewItem | null): string => {
  if (item?.anonymous === true) return ANONYMOUS_REVIEWER_NAME;
  const name = typeof item?.user_details?.name === "string" ? item.user_details.name.trim() : "";
  return name || ANONYMOUS_REVIEWER_NAME;
};

export default getReviewAuthorName;
